import { isUuidV4 } from 'lib/string/uuidV4Utils'

type StreamCursor =
  | { protocol: 'legacy'; cursor: string }
  | { protocol: 'attempt_v1'; cursor: string; messageId: string; generationStreamId: string }

const RAW_CURSOR = /^(?:0|\d{1,20}-\d{1,20})$/

/** Shared by reconnect transport and recovery validation; synthetic IDs are not resumable. */
export function parseStreamCursor(value: string): StreamCursor | undefined {
  if (value.length > 120) return undefined
  if (RAW_CURSOR.test(value)) return { protocol: 'legacy', cursor: value }
  const [version, messageId, generationStreamId, cursor, extra] = value.split(':')
  if (version !== 'tc1' || extra !== undefined || !messageId || !generationStreamId || !cursor ||
    !isUuidV4(messageId) || !isUuidV4(generationStreamId) || !RAW_CURSOR.test(cursor)) return undefined
  return { protocol: 'attempt_v1', messageId, generationStreamId, cursor }
}
